import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect, useState } from "react";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import KryzenTop from "../SI PDF Tables/kryzen_Top";
import SIReport from "../SI PDF Tables/si_report";
import SIDetails from "../SI PDF Tables/si_details";
import PossibleDimentions from "../SI PDF Tables/possible_dimentions";
import Products from "../SI PDF Tables/products";
import { getId } from "../../../Components/Functions/word.fun";
import ProduceTable from "../SI PDF Tables/plants_can_grow";
import SWOT from "../SI PDF Tables/swot";
import Promotion from "../SI PDF Tables/company_promotion";
import FinancialAnalysis from "../SI PDF Tables/financial_analysis";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import KryzenTopQuot from "../../Quatation/PdfQuotationsTables/kryzen_Top";
import CompanyDescription from "../../Quatation/PdfQuotationsTables/company_description";
import UserDetails from "../../Quatation/PdfQuotationsTables/user_details";
import FanPadSpecifications from "../../Quatation/PdfQuotationsTables/fan_pad_specifications";
import NetHouseSpecifications from "../../Quatation/PdfQuotationsTables/net_house_specifications";
import NVPHSpecifications from "../../Quatation/PdfQuotationsTables/nvph_specifications";
import Soilbased_precision_farming from "../../Quatation/PdfQuotationsTables/soilbased_precision_farming";
import CivilMaterials from "../../Quatation/PdfQuotationsTables/civil_materials";
import CustomerResponsibility from "../../Quatation/PdfQuotationsTables/customer_responsibility";
import ScopeOfWork from "../../Quatation/PdfQuotationsTables/scope_of_work";
import TrackingOfProgress from "../../Quatation/PdfQuotationsTables/tracking_of_progress";
import AgronomySupport from "../../Quatation/PdfQuotationsTables/agronomy_support";
import EmployeeTrainingProgramme from "../../Quatation/PdfQuotationsTables/employee_training_programme";
import ElectricFittings from "../../Quatation/PdfQuotationsTables/electric_fittings";
import WaterStorage_Handling from "../../Quatation/PdfQuotationsTables/water_storage_and_handling";
import DutchBucketSetup from "../../Quatation/PdfQuotationsTables/dutch_bucket_setup";
import GrowBagSetup from "../../Quatation/PdfQuotationsTables/grow_bag_setup";
import AFrameSetup from "../../Quatation/PdfQuotationsTables/a_frame_setup";
import FlatBedSetup from "../../Quatation/PdfQuotationsTables/flat_bed_setup";
import SoftwareServices from "../../Quatation/PdfQuotationsTables/software_services";
import MaterialBreakdown from "../../Quatation/PdfQuotationsTables/material_breakdown";
import MaterialBreakdownCEA from "../../Quatation/PdfQuotationsTables/material_breakdown_CEA";
import WorkOrderLocations from "../../Quatation/PdfQuotationsTables/work_order_locations";
import WarrantyOnMaterial from "../../Quatation/PdfQuotationsTables/warranty_on_material";
import QuotationAmounts from "../../Quatation/PdfQuotationsTables/quotation_amounts";
import PaymentBreakdown from "../../Quatation/PdfQuotationsTables/payment_breakdown";
import PaymentDetails from "../../Quatation/PdfQuotationsTables/payment_details";
import BorrowFromBankSchedule2 from "../SI PDF Tables/Borrow From Bank/schedule_2_borrow";
import CheckTemprature from "../SI PDF Tables/checkTemprature";
import { BsCheck2Square } from "react-icons/bs";
import CheckDimentions from "../SI PDF Tables/checkDimentions";

// all quotation v2 imports

import KryzenTopQuotV2 from "../../Quatation/PdfQuotationsTablesV2/kryzen_Top";
import CompanyDescriptionV2 from "../../Quatation/PdfQuotationsTablesV2/company_description";
import UserDetailsV2 from "../../Quatation/PdfQuotationsTablesV2/user_details";
import FanPadSpecificationsV2 from "../../Quatation/PdfQuotationsTablesV2/fan_pad_specifications";
import NetHouseSpecificationsV2 from "../../Quatation/PdfQuotationsTablesV2/net_house_specifications";
import NVPHSpecificationsV2 from "../../Quatation/PdfQuotationsTablesV2/nvph_specifications";
import Soilbased_precision_farmingV2 from "../../Quatation/PdfQuotationsTablesV2/soilbased_precision_farming";
import CivilMaterialsV2 from "../../Quatation/PdfQuotationsTablesV2/civil_materials";
import CustomerResponsibilityV2 from "../../Quatation/PdfQuotationsTablesV2/customer_responsibility";
import ScopeOfWorkV2 from "../../Quatation/PdfQuotationsTablesV2/scope_of_work";
import TrackingOfProgressV2 from "../../Quatation/PdfQuotationsTablesV2/tracking_of_progress";
import AgronomySupportV2 from "../../Quatation/PdfQuotationsTablesV2/agronomy_support";
import EmployeeTrainingProgrammeV2 from "../../Quatation/PdfQuotationsTablesV2/employee_training_programme";
import ElectricFittingsV2 from "../../Quatation/PdfQuotationsTablesV2/electric_fittings";
import WaterStorage_HandlingV2 from "../../Quatation/PdfQuotationsTablesV2/water_storage_and_handling";
import DutchBucketSetupV2 from "../../Quatation/PdfQuotationsTablesV2/dutch_bucket_setup";
import GrowBagSetupV2 from "../../Quatation/PdfQuotationsTablesV2/grow_bag_setup";
import AFrameSetupV2 from "../../Quatation/PdfQuotationsTablesV2/a_frame_setup";
import FlatBedSetupV2 from "../../Quatation/PdfQuotationsTablesV2/flat_bed_setup";
import SoftwareServicesV2 from "../../Quatation/PdfQuotationsTablesV2/software_services";
import MaterialBreakdownV2 from "../../Quatation/PdfQuotationsTablesV2/material_breakdown";
import MaterialBreakdownCEAV2 from "../../Quatation/PdfQuotationsTablesV2/material_breakdown_CEA";
import WorkOrderLocationsV2 from "../../Quatation/PdfQuotationsTablesV2/work_order_locations";
import QuotationAmountsV2 from "../../Quatation/PdfQuotationsTablesV2/quotation_amounts";
import PaymentBreakdownV2 from "../../Quatation/PdfQuotationsTablesV2/payment_breakdown";
import PaymentDetailsV2 from "../../Quatation/PdfQuotationsTablesV2/payment_details";
import ProduceBreakevenTable from "../../Quatation/PdfQuotationsTablesV2/produce_breakeven_table";
import CEACompo from "../../../certificates/CEACompo.jpg";
import CSofHydroponics from "../../../certificates/CSofHydroponics.jpg";
const SiteInspectionPreview = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [newloading, setNewLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allQData, setAllQData] = useState();
  const [image, setImage] = useState("visible");
  const [timer, setTimer] = useState(5);

  const printPDF = () => {
    let name = "project-report";
    if (
      data &&
      (data?.clientDetails?.businessName || data?.clientDetails.clientName)
    ) {
      name = `project-report-${id}-${(
        data?.clientDetails?.businessName || data?.clientDetails.clientName
      )
        .split(" ")
        .join("-")
        .toLowerCase()}`;
    }
    document.title = name;

    window.print();
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/siteInspection/getSiteInspectionById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting SI!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(() => {
    data &&
      (data?.aifQuotationNumber || data?.quotationNumber) &&
      performRequest(
        "GET",
        `/quotations/getQuotationsById/${getId(
          data?.aifQuotationNumber || data?.quotationNumber
        )}`
      )
        .then((res) => {
          setLoading(true);
          if (res.status === 200) {
            let quotationData = res.data;
            let newOpexLabourConst =
              +data?.newSiteInspection?.averageLabourSalary *
              quotationData?.labourCount;
            let newAllOpexCost =
              quotationData?.opex_cost?.opex_all_cost -
              quotationData?.opex_cost?.opex_labour_cost +
              +newOpexLabourConst;
            quotationData = {
              ...quotationData,
              opex_cost: {
                ...quotationData.opex_cost,
                opex_all_cost: newOpexLabourConst
                  ? newAllOpexCost
                  : quotationData?.opex_cost?.opex_all_cost,
                opex_labour_cost:
                  newOpexLabourConst ||
                  quotationData?.opex_cost?.opex_labour_cost,
              },
            };
            setAllQData(quotationData);
            // setAllQData(res.data);
          } else {
            Toast("error", "Error while getting Quotations!");
          }
        })
        .catch((err) => {
          // Toast("error", "Server Error!");
          // console.error(err);
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
  }, [data]);
  useEffect(() => {
    if (allQData?.input_info?.isGrowSlab)
      setTimeout(() => {
        const element = document.getElementById("pdf-content");
        element.innerHTML = element.innerHTML.replace("GROW-BAG", "GROW-SLAB");
        element.innerHTML = element.innerHTML.replace("Grow bag", "Grow slab");
        element.innerHTML = element.innerHTML.replace(
          "grow bags",
          "grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow bags",
          "Grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow Bags",
          "Grow Slabs"
        );
        element.innerHTML = element.innerHTML.replace("Grow Bag", "Grow Slab");
        element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
        element.innerHTML = element.innerHTML.replace("Growbags", "Growslabs");
        element.innerHTML = element.innerHTML.replace("growbags", "growslabs");
      }, 1000);
  }, [allQData]);
  const goBack = () => {
    window.history.back();
  };
  if (loading) {
    return <LoadingPage />;
  }

  const handleNavigate = () => {
    setNewLoading(true);
    setTimer(5); // reset timer

    // Start countdown
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval);
        }
        return prev - 1;
      });
    }, 1000);

    // Your original 5-second delay
    setTimeout(() => {
      const currentPath = window.location.pathname;
      const currentQuery = window.location.search;

      // KEEP the hash
      window.location.href = `${currentPath}${currentQuery}#savePdf`;

      setNewLoading(false);
    }, 5000);
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div
            className="page-header d-print-none"
            style={{ borderBottom: "1px solid #181818", marginBottom: "20px" }}
          >
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title"> Site Inspection</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-auto ms-auto d-print-none">
                <div className="d-flex">
                  {/* <SimpleButton buttonText={"Save Pdf"} onClick={printPDF} /> */}
                  <button
                    className="btn mx-1 mt-2 btn-primary text-white"
                    onClick={handleNavigate}
                    disabled={newloading}
                  >
                    {newloading ? (
                      `Please wait for ${timer} seconds...`
                    ) : (
                      <>
                        <BsCheck2Square className="fs-2 me-2" />
                        NAVIGATE TO DOWNLOAD PDF
                      </>
                    )}
                  </button>

                  <button class="btn mx-1 mt-2 btn-primary" onClick={goBack}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M5 12l14 0" />
                      <path d="M5 12l6 6" />
                      <path d="M5 12l6 -6" />
                    </svg>
                    BACK
                  </button>
                </div>
              </div>
            </div>
          </div>
          {(data?.aifQuotationNumber &&
            data?.aifQuotationNumber?.includes("A/V2")) ||
          (data?.quotationNumber && data?.quotationNumber?.includes("A/V2")) ? (
            <div
              className="card-body"
              style={{ color: "black", fontSize: "17px" }}
            >
              <>
                <div id="pdf-content">
                  {data && allQData && (
                    <KryzenTop data={data} allQData={allQData} />
                  )}
                  {data && allQData && (
                    <SIReport allQData={allQData} data={data} />
                  )}
                  {data && allQData && (
                    <SIDetails data={data} allQData={allQData} />
                  )}
                  <PossibleDimentions />
                  <Products />

                  {data &&
                    allQData &&
                    allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && (
                      <>
                        <ProduceBreakevenTable allQData={allQData} />
                        <div
                          className="html2pdf__page-break"
                          style={{
                            pageBreakAfter: "always",
                            display: "block",
                            clear: "both",
                          }}
                        ></div>
                      </>
                    )}

                  <KryzenTopQuotV2 />
                  {data && allQData && (
                    <CompanyDescriptionV2
                      allQData={allQData}
                      businessName={
                        allQData?.input_info?.businessName ||
                        allQData?.input_info?.contactPersonName
                      }
                      address={allQData?.input_info?.address}
                      data={allQData}
                      quotationType={allQData?.input_info?.quotationType}
                    />
                  )}
                  {allQData && (
                    <UserDetailsV2
                      image={image}
                      userInfo={allQData?.input_info}
                      area={allQData?.area_in}
                    />
                  )}
                  {allQData &&
                    (allQData?.input_info?.quotationType === "fanpad" ||
                      allQData?.input_info?.quotationType ===
                        "soilbasedfanpad" ||
                      allQData?.input_info?.quotationType ===
                        "fanpad with hydroponics") && (
                      <FanPadSpecificationsV2 />
                    )}
                  {allQData &&
                    (allQData?.input_info?.quotationType === "nethouse" ||
                      allQData?.input_info?.quotationType ===
                        "soilbasednethouse" ||
                      allQData?.input_info?.quotationType ===
                        "nethouse with hydroponics") && (
                      <NetHouseSpecificationsV2 />
                    )}
                  {allQData &&
                    (allQData?.input_info?.quotationType === "nvph" ||
                      allQData?.input_info?.quotationType === "soilbasednvph" ||
                      allQData?.input_info?.quotationType ===
                        "nvph with hydroponics") && <NVPHSpecificationsV2 />}

                  {allQData?.input_info &&
                    (allQData?.input_info?.quotationType ===
                      "soilbasedfanpad" ||
                      allQData?.input_info?.quotationType === "soilbasednvph" ||
                      allQData?.input_info?.quotationType ===
                        "soilbasednethouse") &&
                    (allQData?.input_info?.asPerIndustry?.includes(
                      "drip_system"
                    ) ||
                      allQData?.input_info?.asPerIndustry?.includes(
                        "trellising_installation"
                      ) ||
                      allQData?.input_info?.asPerIndustry?.includes(
                        "bed_preparation"
                      ) ||
                      allQData?.input_info?.asPerIndustry?.includes(
                        "mulching_sheet_installation"
                      )) && (
                      <Soilbased_precision_farmingV2
                        asPerIndustry={allQData?.input_info?.asPerIndustry}
                      />
                    )}
                  {allQData?.input_info?.quotationType !==
                    "hydroponics only" && (
                    <div>
                      <div>
                        <img src={CEACompo} alt="CEACompo" />
                      </div>
                      <div
                        className="html2pdf__page-break"
                        style={{
                          pageBreakAfter: "always",
                          display: "block",
                          clear: "both",
                        }}
                      ></div>
                    </div>
                  )}
                  {allQData?.input_info?.quotationType?.includes(
                    "hydroponic"
                  ) && (
                    <div>
                      <div>
                        <img src={CSofHydroponics} alt="CEACompo" />
                      </div>
                      <div
                        className="html2pdf__page-break"
                        style={{
                          pageBreakAfter: "always",
                          display: "block",
                          clear: "both",
                        }}
                      ></div>
                    </div>
                  )}
                  {allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && (
                      <>
                        {allQData &&
                          allQData?.input_info?.flatBedPercent > 0 && (
                            <FlatBedSetupV2 />
                          )}
                        {allQData &&
                          allQData?.input_info?.a_FramePercent > 0 && (
                            <AFrameSetupV2 />
                          )}
                        {allQData &&
                          allQData?.input_info?.growBagPercent > 0 && (
                            <GrowBagSetupV2 />
                          )}
                        {allQData &&
                          allQData?.input_info?.dutchBucketPercent > 0 && (
                            <DutchBucketSetupV2 />
                          )}
                      </>
                    )}

                  {allQData && (
                    <WaterStorage_HandlingV2
                      quotationType={allQData?.input_info?.quotationType}
                      data={allQData?.input_info}
                    />
                  )}
                  {allQData &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" &&
                    allQData?.input_info?.quotationType !== "nethouse" && (
                      <ElectricFittingsV2 data={allQData?.input_info} />
                    )}

                  {allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && (
                      <>
                        <EmployeeTrainingProgrammeV2 />
                        <AgronomySupportV2 />
                      </>
                    )}

                  {allQData && (
                    <TrackingOfProgressV2
                      quotationType={allQData?.input_info?.quotationType}
                    />
                  )}

                  {allQData && (
                    <ScopeOfWorkV2
                      quotationType={allQData?.input_info?.quotationType}
                      a_FramePercent={allQData?.input_info?.a_FramePercent}
                      flatBedPercent={allQData?.input_info?.flatBedPercent}
                      growBagPercent={allQData?.input_info?.growBagPercent}
                      dutchBucketPercent={
                        allQData?.input_info?.dutchBucketPercent
                      }
                    />
                  )}
                  <CustomerResponsibilityV2
                    quotationType={allQData?.input_info?.quotationType}
                  />
                  <CivilMaterialsV2
                    quotationType={allQData?.input_info?.quotationType}
                    a_FramePercent={allQData?.input_info?.a_FramePercent}
                    flatBedPercent={allQData?.input_info?.flatBedPercent}
                    growBagPercent={allQData?.input_info?.growBagPercent}
                    dutchBucketPercent={
                      allQData?.input_info?.dutchBucketPercent
                    }
                  />
                  {allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && <SoftwareServicesV2 />}
                  {allQData &&
                    allQData?.input_info?.quotationType !==
                      "hydroponics only" &&
                    allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && (
                      <MaterialBreakdownV2
                        quotationType={allQData?.input_info?.quotationType}
                      />
                    )}
                  {(allQData?.input_info?.quotationType === "fanpad" ||
                    allQData?.input_info?.quotationType === "nvph" ||
                    allQData?.input_info?.quotationType === "nethouse" ||
                    allQData?.input_info?.quotationType === "soilbasedfanpad" ||
                    allQData?.input_info?.quotationType === "soilbasednvph" ||
                    allQData?.input_info?.quotationType ===
                      "soilbasednethouse") && (
                    <MaterialBreakdownCEAV2
                      quotationType={allQData?.input_info?.quotationType}
                      data={allQData?.input_info}
                    />
                  )}
                  {allQData && (
                    <WorkOrderLocationsV2
                      quotationType={allQData?.input_info?.quotationType}
                      a_FramePercent={allQData?.input_info?.a_FramePercent}
                      flatBedPercent={allQData?.input_info?.flatBedPercent}
                      growBagPercent={allQData?.input_info?.growBagPercent}
                      dutchBucketPercent={
                        allQData?.input_info?.dutchBucketPercent
                      }
                      allQData={allQData}
                      image={image}
                    />
                  )}
                  {allQData && (
                    <>
                      <WarrantyOnMaterial
                        quotationType={allQData?.input_info?.quotationType}
                        data={allQData}
                      />
                      <div
                        className="html2pdf__page-break"
                        style={{
                          pageBreakAfter: "always",
                          display: "block",
                          clear: "both",
                        }}
                      ></div>
                    </>
                  )}

                  <KryzenTopQuot />
                  {allQData && (
                    <QuotationAmountsV2
                      allQData={allQData}
                      quotationType={allQData?.input_info?.quotationType}
                    />
                  )}
                  {allQData && <PaymentBreakdownV2 allQData={allQData} />}
                  {allQData && <PaymentDetailsV2 data={allQData?.input_info} />}
                </div>
              </>
              <div
                className="html2pdf__page-break"
                style={{
                  pageBreakAfter: "always",
                  display: "block",
                  clear: "both",
                }}
              ></div>
              {data &&
              allQData &&
              allQData?.input_info?.quotationType !== "fanpad" &&
              allQData?.input_info?.quotationType !== "nvph" &&
              allQData?.input_info?.quotationType !== "nethouse" &&
              allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
              allQData?.input_info?.quotationType !== "soilbasednvph" &&
              allQData?.input_info?.quotationType !== "soilbasednethouse" &&
              data?.appliedForAIFDPR &&
              data?.borrowFromBank ? (
                <BorrowFromBankSchedule2 data={data} allQData={allQData} />
              ) : (
                ""
              )}

              {/* DPR */}
              {data &&
                allQData &&
                allQData?.input_info?.quotationType !== "fanpad" &&
                allQData?.input_info?.quotationType !== "nvph" &&
                allQData?.input_info?.quotationType !== "nethouse" &&
                allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                allQData?.input_info?.quotationType !== "soilbasednvph" &&
                allQData?.input_info?.quotationType !== "soilbasednethouse" && (
                  <div
                    className={
                      data?.appliedForAIFDPR && data?.borrowFromBank
                        ? "d-print-none"
                        : ""
                    }
                  >
                    <FinancialAnalysis data={data} allQData={allQData} />
                  </div>
                )}

              {data && <SWOT data={data} />}
              {data && <Promotion data={data} />}
            </div>
          ) : (
            <div
              className="card-body"
              style={{ color: "black", fontSize: "17px" }}
            >
              <div id="pdf-content">
                {data && allQData && (
                  <KryzenTop data={data} allQData={allQData} />
                )}
                {/* {data && allQData && (
              <TableOfContent allQData={allQData} data={data} />
            )} */}
                {data && allQData && (
                  <SIReport allQData={allQData} data={data} />
                )}
                {data && allQData && (
                  <SIDetails data={data} allQData={allQData} />
                )}
                <PossibleDimentions />

                <Products />

                {data &&
                  allQData &&
                  allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" &&
                  allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                  allQData?.input_info?.quotationType !== "soilbasednvph" &&
                  allQData?.input_info?.quotationType !==
                    "soilbasednethouse" && (
                    <>
                      <ProduceTable allQData={allQData} />

                      <div
                        className="html2pdf__page-break"
                        style={{
                          pageBreakAfter: "always",
                          display: "block",
                          clear: "both",
                        }}
                      ></div>
                    </>
                  )}

                {data &&
                  allQData &&
                  (allQData?.input_info?.quotationType === "nvph" ||
                    allQData?.input_info?.quotationType === "nethouse" ||
                    allQData?.input_info?.quotationType === "soilbasednvph" ||
                    allQData?.input_info?.quotationType ===
                      "soilbasednethouse" ||
                    allQData?.input_info?.quotationType ===
                      "nethouse with hydroponics" ||
                    allQData?.input_info?.quotationType ===
                      "nvph with hydroponics") && (
                    <>
                      <CheckTemprature SIData={data} />
                    </>
                  )}
                {data && allQData && (
                  <>
                    <CheckDimentions SIData={data} allQData={allQData} />
                  </>
                )}

                <div className="card-body" id="pdf-content">
                  <KryzenTopQuot />
                  {data && allQData && (
                    <CompanyDescription
                      allQData={allQData}
                      businessName={
                        allQData?.input_info?.businessName ||
                        allQData?.input_info?.contactPersonName
                      }
                      address={allQData?.input_info?.address}
                      data={allQData}
                      quotationType={allQData?.input_info?.quotationType}
                    />
                  )}
                  {allQData && (
                    <UserDetails
                      userInfo={allQData?.input_info}
                      area={allQData?.area_in}
                      image={image}
                    />
                  )}
                  {allQData &&
                    (allQData?.input_info?.quotationType === "fanpad" ||
                      allQData?.input_info?.quotationType ===
                        "soilbasedfanpad" ||
                      allQData?.input_info?.quotationType ===
                        "fanpad with hydroponics") && <FanPadSpecifications />}
                  {allQData &&
                    (allQData?.input_info?.quotationType === "nethouse" ||
                      allQData?.input_info?.quotationType ===
                        "soilbasednethouse" ||
                      allQData?.input_info?.quotationType ===
                        "nethouse with hydroponics") && (
                      <NetHouseSpecifications />
                    )}
                  {allQData &&
                    (allQData?.input_info?.quotationType === "nvph" ||
                      allQData?.input_info?.quotationType === "soilbasednvph" ||
                      allQData?.input_info?.quotationType ===
                        "nvph with hydroponics") && <NVPHSpecifications />}
                  {(allQData?.input_info?.quotationType === "soilbasedfanpad" ||
                    allQData?.input_info?.quotationType === "soilbasednvph" ||
                    allQData?.input_info?.quotationType ===
                      "soilbasednethouse") && <Soilbased_precision_farming />}
                  {/* percent wise setup */}
                  {allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && (
                      <>
                        {allQData &&
                          allQData?.input_info?.flatBedPercent > 0 && (
                            <FlatBedSetup />
                          )}
                        {allQData &&
                          allQData?.input_info?.a_FramePercent > 0 && (
                            <AFrameSetup />
                          )}
                        {allQData &&
                          allQData?.input_info?.growBagPercent > 0 && (
                            <GrowBagSetup />
                          )}
                        {allQData &&
                          allQData?.input_info?.dutchBucketPercent > 0 && (
                            <DutchBucketSetup />
                          )}
                        <div
                          className="html2pdf__page-break"
                          style={{
                            pageBreakAfter: "always",
                            display: "block",
                            clear: "both",
                          }}
                        ></div>
                      </>
                    )}

                  {allQData && (
                    <WaterStorage_Handling
                      quotationType={allQData?.input_info?.quotationType}
                      data={allQData?.input_info}
                    />
                  )}
                  {allQData &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" &&
                    allQData?.input_info?.quotationType !== "nethouse" && (
                      <ElectricFittings data={allQData?.input_info} />
                    )}
                  {allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && (
                      <>
                        <EmployeeTrainingProgramme />
                        <AgronomySupport />
                      </>
                    )}
                  <TrackingOfProgress image={image} />

                  {allQData && (
                    <ScopeOfWork
                      quotationType={allQData?.input_info?.quotationType}
                      image={image}
                    />
                  )}
                  <CustomerResponsibility image={image} />

                  <CivilMaterials
                    image={image}
                    quotationType={allQData?.input_info?.quotationType}
                  />
                  {/* working panding */}
                  {/* <AfterSalesServices_AMC /> */}
                  {allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && <SoftwareServices image={image} />}
                  {allQData &&
                    allQData?.input_info?.quotationType !==
                      "hydroponics only" &&
                    allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && <MaterialBreakdown />}
                  {(allQData?.input_info?.quotationType === "fanpad" ||
                    allQData?.input_info?.quotationType === "nvph" ||
                    allQData?.input_info?.quotationType === "nethouse" ||
                    allQData?.input_info?.quotationType === "soilbasedfanpad" ||
                    allQData?.input_info?.quotationType === "soilbasednvph" ||
                    allQData?.input_info?.quotationType ===
                      "soilbasednethouse") && <MaterialBreakdownCEA />}
                  {allQData && (
                    <WorkOrderLocations
                      quotationType={allQData?.input_info?.quotationType}
                      image={image}
                    />
                  )}

                  <WarrantyOnMaterial
                    quotationType={allQData?.input_info?.quotationType}
                  />

                  <div
                    className="html2pdf__page-break"
                    style={{
                      pageBreakAfter: "always",
                      display: "block",
                      clear: "both",
                    }}
                  ></div>
                  <KryzenTopQuot />
                  {allQData && <QuotationAmounts allQData={allQData} />}
                  {allQData && <PaymentBreakdown allQData={allQData} />}
                  {allQData && (
                    <PaymentDetails
                      finalQuotation={allQData?.input_info?.finalQuotation}
                    />
                  )}
                </div>
                <div
                  className="html2pdf__page-break"
                  style={{
                    pageBreakAfter: "always",
                    display: "block",
                    clear: "both",
                  }}
                ></div>
                {data &&
                allQData &&
                allQData?.input_info?.quotationType !== "fanpad" &&
                allQData?.input_info?.quotationType !== "nvph" &&
                allQData?.input_info?.quotationType !== "nethouse" &&
                allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                allQData?.input_info?.quotationType !== "soilbasednvph" &&
                allQData?.input_info?.quotationType !== "soilbasednethouse" &&
                data?.appliedForAIFDPR &&
                data?.borrowFromBank ? (
                  <BorrowFromBankSchedule2 data={data} allQData={allQData} />
                ) : (
                  ""
                )}

                {/* DPR */}
                {data &&
                  allQData &&
                  allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" &&
                  allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                  allQData?.input_info?.quotationType !== "soilbasednvph" &&
                  allQData?.input_info?.quotationType !==
                    "soilbasednethouse" && (
                    <div
                      className={
                        data?.appliedForAIFDPR && data?.borrowFromBank
                          ? "d-print-none"
                          : ""
                      }
                    >
                      <FinancialAnalysis data={data} allQData={allQData} />
                    </div>
                  )}

                {data && <SWOT data={data} />}
                {data && <Promotion data={data} />}
              </div>
            </div>
          )}
          <div className="page-header d-print-none">
            <hr></hr>
            <div className="row g-2 align-items-center">
              {/* <div className="col">
                <h2 className="page-title"> Site Inspection</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div> */}
              <div className="col-auto ms-auto d-print-none">
                <div className="d-flex">
                  <SimpleButton buttonText={"Save Pdf"} onClick={printPDF} />
                  <button class="btn mx-1 mt-2 btn-primary" onClick={goBack}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M5 12l14 0" />
                      <path d="M5 12l6 6" />
                      <path d="M5 12l6 -6" />
                    </svg>
                    BACK
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="savePdf"></div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default SiteInspectionPreview;
